// extracted by mini-css-extract-plugin
export default {"infoIcon":"infoIconSiuTN"};